import Stars from "components/DynamicComponent/atoms/Stars"
import Link from "next/link"

export default function ClientReview({ client_name, category, stars, client_location, excerpt, slug }) {
  return (
    <article className="p-7 bg-white flex flex-col h-full max-h-fit justify-center gap-4 border-0.5 border-grey-cool">
      <h2 className="text-center">
        <span className="block text-base font-primary font-medium text-primary mb-3 capitalize ">{category?.name}</span>
        <span className="text-primary text-m3 lg:text-l1">{client_name}</span>
      </h2>
      <div className="mx-auto flex flex-col items-center">
        <Stars blok={{ rating: stars }} starWidth={20} />
        <h3 className="text-center text-primary">{client_location}</h3>
      </div>
      <p className="text-center">{excerpt}</p>
      <Link
        href={slug}
        target="_self"
        className="underline decoration-secondary hover:decoration-tertiary decoration-2 underline-offset-8 relative mx-auto table"
      >
        Read Full Review
      </Link>
    </article>
  )
}
